/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tiny_Key_Jackdaw_CoaxInputs */

const en_tiny_key_jackdaw_coax = /** @type {(inputs: Tiny_Key_Jackdaw_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit export created`)
};

const de_tiny_key_jackdaw_coax = /** @type {(inputs: Tiny_Key_Jackdaw_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit-Export erstellt`)
};

/**
* | output |
* | --- |
* | "Audit export created" |
*
* @param {Tiny_Key_Jackdaw_CoaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tiny_key_jackdaw_coax = /** @type {((inputs?: Tiny_Key_Jackdaw_CoaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tiny_Key_Jackdaw_CoaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tiny_key_jackdaw_coax(inputs)
	return de_tiny_key_jackdaw_coax(inputs)
});